// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjEuNDEgNC42NyAyLjQ4IDMuMTggMy41NCA0LjY3IDEuNDEgNC42NyIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIzLjU0IDUuMzMgMi40OCA2LjgyIDEuNDEgNS4zMyAzLjU0IDUuMzMiLz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** IAAnywhere Branded Styling **/

:root {
    /* Fonts */

    --opensans-font: 'Open Sans', sans-serif;
    --opensans-light: 300;
    --opensans-regular: 400;
    --opensans-semibold: 600;

    --roboto-font: 'Roboto', sans-serif;
    --roboto-light: 300;
    --roboto-regular: 400;
    --roboto-medium: 500;
    --roboto-semibold: 600;

    --font-size: 16px;
    --line-height: 1.5;
    --font-weight: --opensans-light;

    /* Branded Colors */

    --white: #ffffff;
    --white-002: #fbfbfb;
    --white-003: #f7f8fa;

    --body-background: #ebecee;
    --border-grey: #ddd;
    --grey-001: #3f4554;
    --grey-002: #323439;
    --grey-003: #495061;
    --grey-004: #9a9faa;
    --grey-005: #808695;
    --grey-006: #b0b4bd;
    --grey-007: #a9a9a9;

    --aqua-001: #04c3ca;
    --aqua-002: #1cd5db;
    --aqua-003: #dde3ec;
    --aqua-004: #8290a3;
    --aqua-005: #ebfafb;

    --red-001: #d91e18;
    --red-002: #a35151;

    --green-001: #51a351;

    --black-001: #495057;
    --black-002: #212529;
}

/* Viewport Size Breakpoints */

/** --g-3xs: 320px;  double extra small devices (<=320px) **/

/** --g-2xs: 446px;  double extra small devices (<=445px) **/

/** --g-sm: 576px;  small devices (landscape phones, >=576 & <=766) **/

/** --g-md: 767px;  medium devices (tablets, >=767 & <=991) **/

/** --g-lg: 992px;  large devices (desktops, >=992 & <=1199) **/

/** --g-xl: 1200px;  extra large devices (large desktops, >=1200) **/

@custom-media --3xs-viewport (max-width: 320px);

@custom-media --3xs-min-viewport (min-width: 320px);

@custom-media --2xs-viewport (max-width: 446px);

@custom-media --2xs-min-viewport (min-width: 446px);

/* GLOBAL RESETS */

ul {
  list-style-type: none;
}

ul,
li,
p,
h1,
h2,
h3,
h4,
h5,
h6,
address {
  margin: 0;
  padding: 0;  
}

table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

small, .small {
    font-size: 80%;
    font-weight: 400;
}

/* HTML */

html {
  font-size: 16px;
  overflow-x: hidden;
}

/* BODY */

body {
  font-size: 1rem;
  font-weight: --opensans-light;
  font-family: 'Open Sans', sans-serif, 'Roboto', sans-serif;
  background: #ebecee !important;
  line-height: 1.5;
}

/* HEADER */

header {
  width: 100%;
  background: #ffffff;
}

header .logo {
    display: table;
    vertical-align: middle;
  }

header .logo a img {
      display: table-cell;
    }

header .user {
    display: table;
    position: relative;
    top: 4px;
  }

header .user svg {
      color: #9a9faa;
    }

header .user .notifications {
      display: table-cell;
      vertical-align: middle;
    }

header .user .notifications svg.notification-icon {
        cursor: pointer;
        font-size: 20px;
        margin-right: 32px;
      }

header .user .notifications svg.notification-icon:hover {
            color: hsl(221.29999999999995, 8.6%, 57.2%);
        }

header .user svg.avatar {
        font-size: 52px;
    }

header .user .user-profile {
      display: table-cell;
      vertical-align: middle;
    }

header .user .user-profile h3 {
        color: #3f4554;
        font-size: 1rem;
        font-family: 'Roboto', sans-serif;
        font-weight: 500;
        line-height: 18px;
        max-width: 279px;      
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

header .user .user-profile h3 span {
          color: #04c3ca;
          font-size: 1rem;
          font-family: 'Roboto', sans-serif;
          font-weight: 500;
        }

header .user .user-profile span {
        color: #3f4554;
        font-size: 13px;
        font-weight: 300;
        line-height: 13px;
      }

/* HEADER NAVBAR */

.navbar {
  padding: 0;
  background: #495061;
}

.navbar .navbar-nav {
    flex-direction: row;
  }

.navbar .navbar-nav a.nav-link {
      color: #9a9faa;
      font-size: 1rem;
      font-family: 'Open Sans', sans-serif;
      font-weight: 600;
      padding: 9px 23px;
      transition: background-color 0.15s ease-in-out;
      line-height: 31px;
    }

.navbar .navbar-nav a.nav-link.active {
        color: #04c3ca;
        background-color: #3f4554;
      }

.navbar .navbar-nav a.nav-link:hover {
        color: #1cd5db;
        background-color: #3f4554;
      }

/* ANCHORS */

a {
  text-decoration: none;
  border: 0;
  outline: none;
}

a:hover,
  a:focus {
    text-decoration: none;
    border: 0;
    outline: none;
  }

a img {
    text-decoration: none;
    border: 0;
    outline: none;
  }

/* INPUTS */

input, 
input[type='text'],  
input[type='phone'],
input[type='email'],
input[type='password'] {
  -webkit-appearance: none;
  -moz-appearance: none;
  height: 38px;
  border: 1px solid #a9a9a9;  
  border-radius: 0px;  
  padding: 0.375rem 0.75rem;

}

input::-webkit-input-placeholder,
  input:-moz-placeholder,
  input::-moz-placeholder,
  input:-ms-input-placeholder,
  input::-ms-input-placeholder,
  input::placeholder,
  input[type='text']::-webkit-input-placeholder,
  input[type='text']:-moz-placeholder,
  input[type='text']::-moz-placeholder,
  input[type='text']:-ms-input-placeholder,
  input[type='text']::-ms-input-placeholder,
  input[type='text']::placeholder,
  input[type='phone']::-webkit-input-placeholder,
  input[type='phone']:-moz-placeholder,
  input[type='phone']::-moz-placeholder,
  input[type='phone']:-ms-input-placeholder,
  input[type='phone']::-ms-input-placeholder,
  input[type='phone']::placeholder,
  input[type='email']::-webkit-input-placeholder,
  input[type='email']:-moz-placeholder,
  input[type='email']::-moz-placeholder,
  input[type='email']:-ms-input-placeholder,
  input[type='email']::-ms-input-placeholder,
  input[type='email']::placeholder,
  input[type='password']::-webkit-input-placeholder,
  input[type='password']:-moz-placeholder,
  input[type='password']::-moz-placeholder,
  input[type='password']:-ms-input-placeholder,
  input[type='password']::-ms-input-placeholder,
  input[type='password']::placeholder {
    color: #323439;
    font-size: 14px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 300;
    opacity: 1;
  }

input.error,input[type='text'].error,input[type='phone'].error,input[type='email'].error,input[type='password'].error{    
      border: 1px solid #cc0000 !important;    
  }

input:focus, input[type='text']:focus, input[type='phone']:focus, input[type='email']:focus, input[type='password']:focus {
    outline: 0;
    border:1px solid #212529;
  }

/* SELECTS */

select.form-control {    
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  color: #212529;
  background-color: #ffffff!important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 95% 50%;
  background-position-x: right;
  padding-right: 20px;
  font-family: 'Open Sans', sans-serif;
  font-size: 11.7px;
  text-transform: uppercase;    
  border-radius: 0px;    
  height: 38px;
  border-color: #a9a9a9;
}

select.form-control.form-control:focus{
    border-color:unset;
    box-shadow:unset;
    outline: 0;
    color: #212529;
  }

select.form-control:disabled{
    background-color: #f7f8fa!important;
    border-color: #ddd;
  }

/* BUTTONS */

.btn {
  cursor: pointer;
  padding: 5px 20px;
  display: inline-block;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 11.7px;
  line-height: 17px;
  border-radius: 20px;
  text-transform: uppercase;
}

.btn.btn-icon {
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  border: none;
  border-radius: 0;
  text-transform: uppercase;  
  padding: 0px;
  border-radius: 0px;
}

.btn.btn-aqua {
  color: #ffffff;
  border: #04c3ca;
  background-color: #04c3ca;
}

.btn.btn-aqua:hover,
  .btn.btn-aqua:active {
    color: #ffffff;
    border-color: hsl(182.10000000000002, 96.1%, 36.8%);
    background-color: hsl(182.10000000000002, 96.1%, 38.4%);
  }

.btn.btn-aqua:active:focus {
    color: #ffffff;
    border-color: hsl(182.10000000000002, 96.1%, 34.7%);
    background-color: hsl(182.10000000000002, 96.1%, 36.4%);
  }

.btn.btn-aqua:disabled {
    color: #dde3ec;
    opacity: 1;
    cursor: not-allowed;
    border-color: hsl(182.10000000000002, 96.1%, 36.8%);
    background-color: hsl(182.10000000000002, 96.1%, 38.4%);
  }

.btn.btn-red {
  color: #ffffff;
  border: #d91e18;
  background-color: #d91e18;
}

.btn.btn-red:hover,
  .btn.btn-red:active {
    color: #ffffff;
    border-color: hsl(1.8999999999999773, 80.1%, 43%);
    background-color: hsl(1.8999999999999773, 80.1%, 44.9%);
  }

.btn.btn-red:active:focus {
    color: #ffffff;
    border-color: hsl(1.8999999999999773, 80.1%, 40.6%);
    background-color: hsl(1.8999999999999773, 80.1%, 42.5%);
  }

.btn.btn-dark {
  color: #ffffff;
  border: #495061;
  background-color: #495061;
}

.btn.btn-dark:hover,
  .btn.btn-dark:active {
    color: #ffffff;
    border-color: hsl(222.5, 14.1%, 30.3%);
    background-color: hsl(222.5, 14.1%, 31.7%);
  }

.btn.btn-dark:active:focus {
    color: #ffffff;
    border-color: hsl(222.5, 14.1%, 28.7%);
    background-color: hsl(222.5, 14.1%, 30%);
  }

.btn.btn-white {
  color: #04c3ca;
  border: #ffffff;
  background-color: #ffffff;
}

.btn.btn-white:hover,
  .btn.btn-white:active {
    color: #04c3ca;
    border-color: hsl(0, 0%, 91%);
    background-color: hsl(0, 0%, 95%);
  }

.btn.btn-white:active:focus {
    color: #04c3ca;
    border-color: hsl(0, 0%, 91%);
    background-color: hsl(0, 0%, 95%);
  }

.btn-wrapper {
  text-align: center;
  padding-top: 29px;
}

/* CONTENT CONTAINER */

.content-wrapper {
  background: #ffffff;
  box-shadow: 10px 11px 52px 0px rgba(222, 223, 224, 1);
}

.content-wrapper > h3 {
    color: #ffffff;
    background-color: #04c3ca;
    padding: 8px 30px;
    font-size: 1rem;
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 1px;
    line-height: 26px;
  }

.content-wrapper > h3 svg {
        margin-right: 12px;
    }

.content-wrapper .content-body {
    padding: 29px;
  }

.content-wrapper .content-body.no-padding {
      padding: 0;
    }

.content-wrapper.dark > h3 {
  color: #ffffff;
  background-color: #495061;
}

.content-wrapper.add-margin-top {
    margin-top: 42px;
}

.content-wrapper.add-margin-bottom {
    margin-bottom: 42px;
}

/* TABLE */

.table {
  display: table;
  width: 100%;
  height: 100%;
  margin: 0;
  border: 1px solid #ddd;
  border-collapse: collapse;
  font-size: 13px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 300;
}

.table header {
    display: table-row;
  }

.table header > div {
      font-size: 1rem;
      font-family: 'Roboto', sans-serif;
      font-weight: 400;
      display: table-cell;
      padding: 11px 14px;
      border: 1px solid #ddd;
      vertical-align: bottom;
    }

.table > div {
    display: table-row;
  }

.table > div > div {
      display: table-cell;
      padding: 11px 14px;
      border: 1px solid #ddd;
    }

.table > div > div > div {
        display: none;
      }

.table > div > div span.nowrapping{
          white-space: nowrap;
        }

.table > div:nth-of-type(odd) {
      background-color: #f7f8fa;
    }

.table > div:nth-of-type(even) {
      background-color: #fbfbfb;
    }

/* FOOTER */

footer {
  background: #495061;
}

footer .footer-flex {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;

    padding-top: 30px;
    padding-bottom: 30px;
  }

footer .footer-flex div {
      flex: 1;
      margin-right: 2%;
    }

footer .footer-flex div h3 {
        color: #1cd5db;
        font-size: 1rem;
        font-family: 'Open Sans', sans-serif;
        font-weight: 600;
        text-transform: uppercase;
        line-height: 18px;
      }

footer .footer-flex div h4 {
        color: #ffffff;
        font-size: 1rem;
        font-family: 'Roboto', sans-serif;
        font-weight: 300;
        padding-top: 11px;
        padding-top: 11px;
      }

footer .footer-flex div ul {
        padding-top: 11px;
      }

footer .footer-flex div ul li {
          line-height: 15px;
          padding-bottom: 8px;
        }

footer .footer-flex div ul li a {
            color: #ffffff;
            font-size: 1rem;
            font-family: 'Roboto', sans-serif;
            font-weight: 300;
            display: inline-block;
            line-height: 14px;
          }

footer .footer-flex div ul li a svg {
              color: #04c3ca;
              font-size: 22px;
            }

footer .footer-flex div.follow-us {
        text-align: right;
      }

footer .footer-flex div.follow-us ul li {
            padding: 0;
            display: inline-block;
            line-height: 12px;
            margin-right: 12px;
          }

footer .footer-flex div.follow-us ul li:last-child {
              margin-right: 0;
            }

footer .footer-flex div:last-child {
        margin-right: 0;
      }

/* FOOTER > COPYRIGHT */

footer .copyright {
    background: #3f4554;
  }

footer .copyright .copyright-flex {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      color: #808695;
      font-family: 'Roboto', sans-serif;
      font-weight: 300;
      font-size: 15px;
      line-height: 17px;
      padding-top: 15px;
      padding-bottom: 15px;
    }

footer .copyright .copyright-flex span a {
        color: #b0b4bd;
      }

footer .copyright .copyright-flex span a:hover {
        color: #04c3ca;
      }

footer .copyright .copyright-flex ul li {
          display: inline-block;
          border-left: 1px solid #808695;
          margin-left: 8px;
          padding-left: 10px;
          line-height: 16px;
        }

footer .copyright .copyright-flex ul li a {
            color: #808695;
          }

footer .copyright .copyright-flex ul li a img{
              width: 8.125rem;
            }

footer .copyright .copyright-flex ul li:first-of-type {
            border: none;
          }

footer .social-icon {
    height: 25px;
  }

/* GLOBAL */

au-viewport {
  display: block;
  height: 100%;
  width: 100%;
  min-height: calc(100vh - 358px );
}

section.au-animate {
  animation: fadeIn 1s;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/** Error & Validation message styling **/

.error {
  border: 1px solid #cc0000 !important;
}

.validation-message-container {
  margin-top: 0.46875rem;
  display: block;
  color: #cc0000;
}

/** NProgress bar custom Brand styling **/

#nprogress .bar {
    background: #04c3ca;
  }

#nprogress .peg {
    box-shadow: 0 0 10px #04c3ca, 0 0 5px #04c3ca;
  }

#nprogress .spinner-icon {
    border-top-color: #04c3ca;
    border-left-color: #04c3ca;
  }

.go-back {
  clear: both;
  text-align: center;
  padding-top: 40px;
  padding-bottom: 40px;
}

.center {
  text-align: center;
  width: 15%;
}

@media screen and (max-width: 767px){
  .center {   
    width: unset;
  } 
}

/* HEADER */

.profile-menu {
  display: none;
  position: absolute;
  left: 0px;
  top: 60px;
  background-color: #323439;

  min-width: 160px;
  overflow: auto;
  z-index: 1;
}

.profile-menu a {
  color: #b0b4bd !important;
  font-size: 13px;
  padding-left: 30px;
}

.profile-menu a:hover {
  background-color: #495061;
}

.profile-menu-show {
  display: block !important;
}

.profile-close-btn {
  display: none;
}

.profile-menu-sublinks {
  background-color: #808695;
  max-height: 0px;
  transition: max-height 0.4s ease-out;
  overflow: hidden;
}

.profile-menu-sublinks a {
  color: #323439 !important;
}

.profile-menu-sublinks-show {
  max-height: 300px;
}

.profile-menu-sublinks a:hover {
  background-color: #9a9faa;
}

.profile-sublinks-arrow {
  margin-left: 5px;
  margin-bottom: 3px;
  pointer-events: none;
}

.profile-sublinks-arrow-up {
  margin-left: 5px;
  margin-bottom: -2px;
  pointer-events: none;
}

.paidFunded{
  color: #51a351;
  font-weight: 600
}

p {
  font-family: 'Open Sans', sans-serif;  
  font-weight: 300;
  font-size: 13px;
}

.title{
  text-transform: uppercase; 
  padding-bottom: 15px;
  font-family: unset;
  font-weight: 600;
}

.creditAmount{
  color: #d91e18;
}

/************** Media css start **************/

@media screen and (max-width: 1200px) {
    .content-wrapper > h3 {
      padding: 8px 15px;
    }
    .content-wrapper .content-body {
        padding: 15px;
    }
      .table header > div {
        font-size: 14px;
      }
  .btn {
    padding: 4px 18px;
  }
  .btn-wrapper {
    padding-top: 15px;
  }
}

@media screen and (max-width: 992px) {
      footer .copyright .copyright-flex {
        font-size: 14px;
      }
}

@media screen and (max-width: 767px) {
    .content-wrapper > h3 {
      font-size: 15px;
    }
    .content-wrapper .content-body {
      padding: 35px 15px;
    }

  .table {
    display: block;
    border: none;
  }
    .table header {
      display: none;
    }
    .table > div {
      display: block;
      background-color: transparent;
    }
          .table > div:last-child > div:last-child {
            margin-bottom: 0;
          }

      .table > div > div {
        display: block;
        text-align: center;
        padding: 11px 15px;
        border-top: none;
      }
        .table > div > div:nth-of-type(odd) {
          background-color: #f7f8fa;
        }
        .table > div > div:nth-of-type(even) {
          background-color: #fbfbfb;
        }
        .table > div > div:first-child {
          border-top: 3px solid #04c3ca;
        }
        .table > div > div:last-child {
            margin-bottom: 20px;
        }

        .table > div > div > div {
          display: block;
          font-size: 15px;
          font-family: 'Roboto', sans-serif;
          font-weight: 400;
        }

  .btn {
    padding: 4px 10px;
  }
  .btn.btn-aqua,
  .btn.btn-dark {
    margin: 0;
    padding: 9px 25px;
  }
    header .user {
      top: 0;
    }
      header .user .notifications,
      header .user .user-profile {
        display: none !important;
      }
    footer .footer-flex {
      flex-flow: column nowrap;
      padding: 35px 0;
    }
      footer .footer-flex div {
        margin-right: 0;
        margin-bottom: 25px;
        text-align: center;
      }
        footer .footer-flex div h4 {
            padding-top: 2px;
        }
        footer .footer-flex div ul {
            padding-top: 8px;
        }
        footer .footer-flex div.follow-us {
          text-align: center;
        }
          footer .footer-flex div.follow-us ul {
            text-align: center;
            padding-top: 12px;
          }
            footer .footer-flex div.follow-us ul li {
              margin: 0 15px;
            }
              footer .footer-flex div.follow-us ul li:first-of-type {
                margin-left: 0;
              }
        footer .footer-flex div:last-child {
          margin-bottom: 0;
        }
      footer .copyright .copyright-flex {
        flex-flow: column nowrap;
        flex-direction: column-reverse;
        text-align: center;
      }
        footer .copyright .copyright-flex div {
            margin-bottom: 15px;
        }
          footer .copyright .copyright-flex div:first-child {
            margin-bottom: 0;
          }
}

@media screen and (max-width: 576px) {
    .navbar .container {
      padding: 0;
      display: inline-block;
    }
  a.nav-link {
    flex: 1;
    text-align: center;
  }
            footer .copyright .copyright-flex div ul li {
                margin-left: 4px;
                padding-left: 6px;
            }
  .profile-menu {
    display: block;
    min-width: 250px;
    height: 100%;
    width: 250px;
    position: fixed;
    z-index: 100;
    top: 0;
    right: -250px;
    left: auto;
    overflow-x: hidden;
    transition: right .5s;
    padding-top: 40px;
  }

  .profile-menu a {
    display: block;
    color: #b0b4bd;
    white-space: nowrap;
    font-size: 15px;
    padding-left: 0px;
  }

  .profile-menu-show {
    right: 0px;
  }
  
  .profile-close-btn {
    display: block;
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 30px !important;
    margin-left: 50px;
    color: #b0b4bd !important;
  }

  a.profile-close-btn:hover  {
    background-color: transparent;
  }

  .profile-menu-sublinks {
    max-height: 0px;
    transition: max-height 0.4s ease-out;
    overflow: hidden;
  }

  .profile-menu-sublinks-show {
    max-height: 300px;
  }
  
}

.g-pl-4 {
    padding-left: 0.25rem !important;
}

.g-pb-9 {
    padding-bottom: 0.5625rem !important;
}

.g-pt-15 {
    padding-top: 0.9375rem !important;
}

.g-pr-3 {
    padding-right: 0.1875rem !important;
}

.g-pl-15 {
    padding-left: 0.9375rem !important;
}

.g-pr-5 {
    padding-right: 0.3125rem !important;
}`, "",{"version":3,"sources":["webpack://./src/branding.css","webpack://./src/app.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;IACI,UAAU;;IAEV,wCAAwC;IACxC,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;;IAExB,mCAAmC;IACnC,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,sBAAsB;;IAEtB,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;;IAE/B,mBAAmB;;IAEnB,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;;IAEpB,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;;IAEnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;;IAEnB,kBAAkB;IAClB,kBAAkB;;IAElB,oBAAoB;;IAEpB,oBAAoB;IACpB,oBAAoB;AACxB;;AAGA,8BAA8B;;AAE9B,4DAA4D;;AAC5D,4DAA4D;;AAC5D,sEAAsE;;AACtE,8DAA8D;;AAC9D,+DAA+D;;AAC/D,oEAAoE;;AAUpE,+CAA+C;;AAC/C,mDAAmD;;AACnD,+CAA+C;;AAC/C,mDAAmD;;ACtEnD,kBAAkB;;AAElB;EACE,qBAAqB;AACvB;;AAEA;;;;;;;;;;EAUE,SAAS;EACT,UAAU;AACZ;;AAEA;;;;;;;;EAQE,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,aAAa;EACb,wBAAwB;AAC1B;;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,SAAS;;AAET;EACE,eAA2B;EAC3B,kBAAkB;AACpB;;AAEA,SAAS;;AAET;EACE,eAAe;EACf,6BAA+B;EAC/B,0DAAqD;EACrD,8BAA6C;EAC7C,gBAA+B;AACjC;;AAEA,WAAW;;AAEX;EACE,WAAW;EACX,mBAAwB;AA0D1B;;AAzDE;IACE,cAAc;IACd,sBAAsB;EAIxB;;AAHE;MACE,mBAAmB;IACrB;;AAEF;IACE,cAAc;IACd,kBAAkB;IAClB,QAAQ;EA8CV;;AA7CE;MACE,cAAsB;IACxB;;AACA;MACE,mBAAmB;MACnB,sBAAsB;IASxB;;AARE;QACE,eAAe;QACf,eAAe;QACf,kBAAkB;MAIpB;;AAHE;YACI,2CAAmC;QACvC;;AAGJ;QACI,eAAe;IACnB;;AACA;MACE,mBAAmB;MACnB,sBAAsB;IAwBxB;;AAvBE;QACE,cAAsB;QACtB,eAAe;QACf,iCAA+B;QAC/B,gBAAiC;QACjC,iBAAiB;QACjB,gBAAgB;QAChB,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;MAOrB;;AANE;UACE,cAAsB;UACtB,eAAe;UACf,iCAA+B;UAC/B,gBAAiC;QACnC;;AAEF;QACE,cAAsB;QACtB,eAAe;QACf,gBAAkC;QAClC,iBAAiB;MACnB;;AAKN,kBAAkB;;AAElB;EACE,UAAU;EACV,mBAA2B;AAsB7B;;AArBE;IACE,mBAAmB;EAmBrB;;AAlBE;MACE,cAAsB;MACtB,eAAe;MACf,oCAAiC;MACjC,gBAAqC;MACrC,iBAAiB;MACjB,8CAA8C;MAC9C,iBAAiB;IAUnB;;AARE;QACE,cAAsB;QACtB,yBAAiC;MACnC;;AACA;QACE,cAAsB;QACtB,yBAAiC;MACnC;;AAKN,YAAY;;AAEZ;EACE,qBAAqB;EACrB,SAAS;EACT,aAAa;AAYf;;AAXE;;IAEE,qBAAqB;IACrB,SAAS;IACT,aAAa;EACf;;AACA;IACE,qBAAqB;IACrB,SAAS;IACT,aAAa;EACf;;AAGF,WAAW;;AAEX;;;;;EAKE,wBAAwB;EACxB,qBAAqB;EACrB,YAAY;EACZ,yBAAiC;EACjC,kBAAkB;EAClB,yBAAyB;;AAqB3B;;AApBE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAME,cAAsB;IACtB,eAAe;IACf,oCAAiC;IACjC,gBAAkC;IAClC,UAAU;EACZ;;AACA;MACI,oCAAoC;EACxC;;AACA;IACE,UAAU;IACV,wBAAiC;EACnC;;AAIF,YAAY;;AAEZ;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,cAAuB;EACvB,mCAAwC;EACxC,qEAAie;EACje,4BAA4B;EAC5B,mBAAmB;EACnB,oCAAiC;EACjC,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,qBAA6B;AAW/B;;AAVE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,cAAuB;EACzB;;AACA;IACE,mCAA4C;IAC5C,kBAAgC;EAClC;;AAGF,YAAY;;AAEZ;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,oCAAiC;EACjC,gBAAqC;EACrC,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oCAAiC;EACjC,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAmB;EACnB,eAAuB;EACvB,yBAAiC;AAmBnC;;AAlBE;;IAEE,cAAmB;IACnB,mDAAyC;IACzC,uDAA6C;EAC/C;;AACA;IACE,cAAmB;IACnB,mDAA0C;IAC1C,uDAA8C;EAChD;;AACA;IACE,cAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,mDAAyC;IACzC,uDAA6C;EAC/C;;AAGF;EACE,cAAmB;EACnB,eAAsB;EACtB,yBAAgC;AAYlC;;AAXE;;IAEE,cAAmB;IACnB,iDAAwC;IACxC,uDAA4C;EAC9C;;AACA;IACE,cAAmB;IACnB,mDAAyC;IACzC,uDAA6C;EAC/C;;AAGF;EACE,cAAmB;EACnB,eAAuB;EACvB,yBAAiC;AAYnC;;AAXE;;IAEE,cAAmB;IACnB,sCAAyC;IACzC,0CAA6C;EAC/C;;AACA;IACE,cAAmB;IACnB,sCAA0C;IAC1C,wCAA8C;EAChD;;AAGF;EACE,cAAsB;EACtB,eAAoB;EACpB,yBAA8B;AAYhC;;AAXE;;IAEE,cAAsB;IACtB,6BAAsC;IACtC,iCAA0C;EAC5C;;AACA;IACE,cAAsB;IACtB,6BAAsC;IACtC,iCAA0C;EAC5C;;AAGF;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,sBAAsB;;AACtB;EACE,mBAAwB;EAGxB,qDAAqD;AAsBvD;;AArBE;IACE,cAAmB;IACnB,yBAAiC;IACjC,iBAAiB;IACjB,eAAe;IACf,oCAAiC;IACjC,gBAAoC;IACpC,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;EAKnB;;AAHE;QACI,kBAAkB;IACtB;;AAEF;IACE,aAAa;EAIf;;AAHE;MACE,UAAU;IACZ;;AAIJ;EACE,cAAmB;EACnB,yBAAiC;AACnC;;AACA;IACI,gBAAgB;AACpB;;AACA;IACI,mBAAmB;AACvB;;AAEA,UAAU;;AAEV;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,sBAAoC;EACpC,yBAAyB;EACzB,eAAe;EACf,oCAAiC;EACjC,gBAAkC;AAwCpC;;AAtCE;IACE,kBAAkB;EAWpB;;AATE;MACE,eAAe;MACf,iCAA+B;MAC/B,gBAAkC;MAClC,mBAAmB;MACnB,kBAAkB;MAClB,sBAAoC;MACpC,sBAAsB;IACxB;;AAGF;IACE,kBAAkB;EAsBpB;;AApBE;MACE,mBAAmB;MACnB,kBAAkB;MAClB,sBAAoC;IAUtC;;AATE;QACE,aAAa;MACf;;AAEE;UACE,mBAAmB;QACrB;;AAIJ;MACE,yBAAkC;IACpC;;AACA;MACE,yBAAkC;IACpC;;AAIJ,WAAW;;AAEX;EACE,mBAA2B;AAmH7B;;AAjHE;IACE,aAAa;IACb,qBAAqB;IACrB,8BAA8B;;IAE9B,iBAAiB;IACjB,oBAAoB;EAyDtB;;AAxDE;MACE,OAAO;MACP,gBAAgB;IAqDlB;;AApDE;QACE,cAAsB;QACtB,eAAe;QACf,oCAAiC;QACjC,gBAAqC;QACrC,yBAAyB;QACzB,iBAAiB;MACnB;;AACA;QACE,cAAmB;QACnB,eAAe;QACf,iCAA+B;QAC/B,gBAAgC;QAChC,iBAAiB;QACjB,iBAAiB;MACnB;;AACA;QACE,iBAAiB;MAiBnB;;AAhBE;UACE,iBAAiB;UACjB,mBAAmB;QAarB;;AAZE;YACE,cAAmB;YACnB,eAAe;YACf,iCAA+B;YAC/B,gBAAgC;YAChC,qBAAqB;YACrB,iBAAiB;UAKnB;;AAJE;cACE,cAAsB;cACtB,eAAe;YACjB;;AAIN;QACE,iBAAiB;MAYnB;;AAVI;YACE,UAAU;YACV,qBAAqB;YACrB,iBAAiB;YACjB,kBAAkB;UAIpB;;AAHE;cACE,eAAe;YACjB;;AAIN;QACE,eAAe;MACjB;;AAIJ,uBAAuB;;AAEvB;IACE,mBAA2B;EAwC7B;;AAvCE;MACE,aAAa;MACb,qBAAqB;MACrB,8BAA8B;MAC9B,mBAAmB;MACnB,cAAsB;MACtB,iCAA+B;MAC/B,gBAAgC;MAChC,eAAe;MACf,iBAAiB;MACjB,iBAAiB;MACjB,oBAAoB;IA2BtB;;AAzBE;QACE,cAAsB;MACxB;;AACA;QACE,cAAsB;MACxB;;AAGE;UACE,qBAAqB;UACrB,8BAAsC;UACtC,gBAAgB;UAChB,kBAAkB;UAClB,iBAAiB;QAUnB;;AATE;YACE,cAAsB;UAIxB;;AAHE;cACE,eAAe;YACjB;;AAEF;YACE,YAAY;UACd;;AAMR;IACE,YAAY;EACd;;AAGF,WAAW;;AAEX;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,gCAAgC;AAClC;;AAEA;EAEE,oBAAoB;AACtB;;AAWA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,yCAAyC;;AAEzC;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,cAAc;AAChB;;AAEA,yCAAyC;;AAGvC;IACE,mBAA2B;EAC7B;;AACA;IACE,6CAA6D;EAC/D;;AACA;IACE,yBAAiC;IACjC,0BAAkC;EACpC;;AAGF;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,WAAW;;AACX;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,yBAAiC;;EAEjC,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,yBAAiC;EACjC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAiC;EACjC,eAAe;EACf,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,yBAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAuB;EACvB;AACF;;AAEA;EACE,oCAAiC;EACjC,gBAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAmC;AACrC;;AAEA;EACE,cAAqB;AACvB;;AAEA,8CAA8C;;AAE9C;IAEI;MACE,iBAAiB;IACnB;IACA;QACI,aAAa;IACjB;MAIE;QACE,eAAe;MACjB;EAGJ;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;MAGM;QACE,eAAe;MACjB;AAGN;;AAEA;IAEI;MACE,eAAe;IACjB;IACA;MACE,kBAAkB;IACpB;;EAGF;IACE,cAAc;IACd,YAAY;EAyCd;IAxCE;MACE,aAAa;IACf;IACA;MACE,cAAc;MACd,6BAA6B;IAkC/B;UA/BM;YACE,gBAAgB;UAClB;;MAIJ;QACE,cAAc;QACd,kBAAkB;QAClB,kBAAkB;QAClB,gBAAgB;MAoBlB;QAnBE;UACE,yBAAkC;QACpC;QACA;UACE,yBAAkC;QACpC;QACA;UACE,6BAA6B;QAC/B;QACA;YACI,mBAAmB;QACvB;;QAEA;UACE,cAAc;UACd,eAAe;UACf,iCAA+B;UAC/B,gBAAkC;QACpC;;EAKN;IACE,iBAAiB;EACnB;EACA;;IAEE,SAAS;IACT,iBAAiB;EACnB;IAGE;MACE,MAAM;IAKR;MAJE;;QAEE,wBAAwB;MAC1B;IAKF;MACE,wBAAwB;MACxB,eAAe;IA4BjB;MA3BE;QACE,eAAe;QACf,mBAAmB;QACnB,kBAAkB;MAuBpB;QAtBE;YACI,gBAAgB;QACpB;QACA;YACI,gBAAgB;QACpB;QACA;UACE,kBAAkB;QAWpB;UAVE;YACE,kBAAkB;YAClB,iBAAiB;UAOnB;YANE;cACE,cAAc;YAIhB;cAHE;gBACE,cAAc;cAChB;QAIN;UACE,gBAAgB;QAClB;MAIF;QACE,wBAAwB;QACxB,8BAA8B;QAC9B,kBAAkB;MAOpB;QANE;YACI,mBAAmB;QAIvB;UAHE;YACE,gBAAgB;UAClB;AAKV;;AAEA;IAEI;MACE,UAAU;MACV,qBAAqB;IACvB;EAEF;IACE,OAAO;IACP,kBAAkB;EACpB;YAMU;gBACI,gBAAgB;gBAChB,iBAAiB;YACrB;EAMV;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,MAAM;IACN,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,cAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;IACjB,yBAAiC;EACnC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,oCAAoC;IACpC,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;AAEF;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":["/** IAAnywhere Branded Styling **/\r\n\r\n:root {\r\n    /* Fonts */\r\n\r\n    --opensans-font: 'Open Sans', sans-serif;\r\n    --opensans-light: 300;\r\n    --opensans-regular: 400;\r\n    --opensans-semibold: 600;\r\n\r\n    --roboto-font: 'Roboto', sans-serif;\r\n    --roboto-light: 300;\r\n    --roboto-regular: 400;\r\n    --roboto-medium: 500;\r\n    --roboto-semibold: 600;\r\n\r\n    --font-size: 16px;\r\n    --line-height: 1.5;\r\n    --font-weight: --opensans-light;\r\n\r\n    /* Branded Colors */\r\n\r\n    --white: #ffffff;\r\n    --white-002: #fbfbfb;\r\n    --white-003: #f7f8fa;\r\n\r\n    --body-background: #ebecee;\r\n    --border-grey: #ddd;\r\n    --grey-001: #3f4554;\r\n    --grey-002: #323439;\r\n    --grey-003: #495061;\r\n    --grey-004: #9a9faa;\r\n    --grey-005: #808695;\r\n    --grey-006: #b0b4bd;\r\n    --grey-007: #a9a9a9;\r\n\r\n    --aqua-001: #04c3ca;\r\n    --aqua-002: #1cd5db;\r\n    --aqua-003: #dde3ec;\r\n    --aqua-004: #8290a3;\r\n    --aqua-005: #ebfafb;\r\n\r\n    --red-001: #d91e18;\r\n    --red-002: #a35151;\r\n\r\n    --green-001: #51a351;\r\n\r\n    --black-001: #495057;\r\n    --black-002: #212529;\r\n}\r\n\r\n\r\n/* Viewport Size Breakpoints */\r\n\r\n/** --g-3xs: 320px;  double extra small devices (<=320px) **/\r\n/** --g-2xs: 446px;  double extra small devices (<=445px) **/\r\n/** --g-sm: 576px;  small devices (landscape phones, >=576 & <=766) **/\r\n/** --g-md: 767px;  medium devices (tablets, >=767 & <=991) **/\r\n/** --g-lg: 992px;  large devices (desktops, >=992 & <=1199) **/\r\n/** --g-xl: 1200px;  extra large devices (large desktops, >=1200) **/\r\n\r\n@custom-media --xl-viewport (max-width: 1200px);\r\n@custom-media --xl-min-viewport (min-width: 1200px);\r\n@custom-media --lg-viewport (max-width: 992px);\r\n@custom-media --lg-min-viewport (min-width: 992px);\r\n@custom-media --md-viewport (max-width: 767px);\r\n@custom-media --md-min-viewport (min-width: 767px);\r\n@custom-media --sm-viewport (max-width: 576px);\r\n@custom-media --sm-min-viewport (min-width: 576px);\r\n@custom-media --3xs-viewport (max-width: 320px);\r\n@custom-media --3xs-min-viewport (min-width: 320px);\r\n@custom-media --2xs-viewport (max-width: 446px);\r\n@custom-media --2xs-min-viewport (min-width: 446px);","@import 'branding';\r\n\r\n/* GLOBAL RESETS */\r\n\r\nul {\r\n  list-style-type: none;\r\n}\r\n\r\nul,\r\nli,\r\np,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\naddress {\r\n  margin: 0;\r\n  padding: 0;  \r\n}\r\n\r\ntable,\r\ncaption,\r\ntbody,\r\ntfoot,\r\nthead,\r\ntr,\r\nth,\r\ntd {\r\n  margin: 0;\r\n  padding: 0;\r\n  border: 0;\r\n  font-size: 100%;\r\n  font: inherit;\r\n  vertical-align: baseline;\r\n}\r\ntable {\r\n  border-collapse: collapse;\r\n  border-spacing: 0;\r\n}\r\n\r\nsmall, .small {\r\n    font-size: 80%;\r\n    font-weight: 400;\r\n}\r\n\r\n/* HTML */\r\n\r\nhtml {\r\n  font-size: var(--font-size);\r\n  overflow-x: hidden;\r\n}\r\n\r\n/* BODY */\r\n\r\nbody {\r\n  font-size: 1rem;\r\n  font-weight: var(--font-weight);\r\n  font-family: var(--opensans-font), var(--roboto-font);\r\n  background: var(--body-background) !important;\r\n  line-height: var(--line-height);\r\n}\r\n\r\n/* HEADER */\r\n\r\nheader {\r\n  width: 100%;\r\n  background: var(--white);\r\n  .logo {\r\n    display: table;\r\n    vertical-align: middle;\r\n    a img {\r\n      display: table-cell;\r\n    }\r\n  }\r\n  .user {\r\n    display: table;\r\n    position: relative;\r\n    top: 4px;\r\n    svg {\r\n      color: var(--grey-004);\r\n    }\r\n    .notifications {\r\n      display: table-cell;\r\n      vertical-align: middle;\r\n      svg.notification-icon {\r\n        cursor: pointer;\r\n        font-size: 20px;\r\n        margin-right: 32px;\r\n        &:hover {\r\n            color: darken(var(--grey-004), 10%);\r\n        }\r\n      }\r\n    }\r\n    svg.avatar {\r\n        font-size: 52px;\r\n    }\r\n    .user-profile {\r\n      display: table-cell;\r\n      vertical-align: middle;\r\n      h3 {\r\n        color: var(--grey-001);\r\n        font-size: 1rem;\r\n        font-family: var(--roboto-font);\r\n        font-weight: var(--roboto-medium);\r\n        line-height: 18px;\r\n        max-width: 279px;      \r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;        \r\n        span {\r\n          color: var(--aqua-001);\r\n          font-size: 1rem;\r\n          font-family: var(--roboto-font);\r\n          font-weight: var(--roboto-medium);\r\n        }\r\n      }\r\n      span {\r\n        color: var(--grey-001);\r\n        font-size: 13px;\r\n        font-weight: var(--opensans-light);\r\n        line-height: 13px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* HEADER NAVBAR */\r\n\r\n.navbar {\r\n  padding: 0;\r\n  background: var(--grey-003);\r\n  .navbar-nav {\r\n    flex-direction: row;\r\n    a.nav-link {\r\n      color: var(--grey-004);\r\n      font-size: 1rem;\r\n      font-family: var(--opensans-font);\r\n      font-weight: var(--opensans-semibold);\r\n      padding: 9px 23px;\r\n      transition: background-color 0.15s ease-in-out;\r\n      line-height: 31px;\r\n\r\n      &.active {\r\n        color: var(--aqua-001);\r\n        background-color: var(--grey-001);\r\n      }\r\n      &:hover {\r\n        color: var(--aqua-002);\r\n        background-color: var(--grey-001);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* ANCHORS */\r\n\r\na {\r\n  text-decoration: none;\r\n  border: 0;\r\n  outline: none;\r\n  &:hover,\r\n  &:focus {\r\n    text-decoration: none;\r\n    border: 0;\r\n    outline: none;\r\n  }\r\n  img {\r\n    text-decoration: none;\r\n    border: 0;\r\n    outline: none;\r\n  }\r\n}\r\n\r\n/* INPUTS */\r\n\r\ninput, \r\ninput[type='text'],  \r\ninput[type='phone'],\r\ninput[type='email'],\r\ninput[type='password'] {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  height: 38px;\r\n  border: 1px solid var(--grey-007);  \r\n  border-radius: 0px;  \r\n  padding: 0.375rem 0.75rem;\r\n  &::-webkit-input-placeholder,\r\n  &:-moz-placeholder,\r\n  &::-moz-placeholder,\r\n  &:-ms-input-placeholder,\r\n  &::-ms-input-placeholder,\r\n  &::placeholder {\r\n    color: var(--grey-002);\r\n    font-size: 14px;\r\n    font-family: var(--opensans-font);\r\n    font-weight: var(--opensans-light);\r\n    opacity: 1;\r\n  }\r\n  &.error{    \r\n      border: 1px solid #cc0000 !important;    \r\n  }\r\n  &:focus {\r\n    outline: 0;\r\n    border:1px solid var(--black-002);\r\n  }\r\n\r\n}\r\n\r\n/* SELECTS */\r\n\r\nselect.form-control {    \r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  color: var(--black-002);\r\n  background-color: var(--white)!important;\r\n  background: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjEuNDEgNC42NyAyLjQ4IDMuMTggMy41NCA0LjY3IDEuNDEgNC42NyIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIzLjU0IDUuMzMgMi40OCA2LjgyIDEuNDEgNS4zMyAzLjU0IDUuMzMiLz48L3N2Zz4=) no-repeat 95% 50%;\r\n  background-position-x: right;\r\n  padding-right: 20px;\r\n  font-family: var(--opensans-font);\r\n  font-size: 11.7px;\r\n  text-transform: uppercase;    \r\n  border-radius: 0px;    \r\n  height: 38px;\r\n  border-color: var(--grey-007);\r\n  &.form-control:focus{\r\n    border-color:unset;\r\n    box-shadow:unset;\r\n    outline: 0;\r\n    color: var(--black-002);\r\n  }\r\n  &:disabled{\r\n    background-color: var(--white-003)!important;\r\n    border-color: var(--border-grey);\r\n  }\r\n}\r\n\r\n/* BUTTONS */\r\n\r\n.btn {\r\n  cursor: pointer;\r\n  padding: 5px 20px;\r\n  display: inline-block;\r\n  font-family: var(--opensans-font);\r\n  font-weight: var(--opensans-semibold);\r\n  font-size: 11.7px;\r\n  line-height: 17px;\r\n  border-radius: 20px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.btn.btn-icon {\r\n  font-family: var(--opensans-font);\r\n  font-size: 13px;\r\n  border: none;\r\n  border-radius: 0;\r\n  text-transform: uppercase;  \r\n  padding: 0px;\r\n  border-radius: 0px;\r\n}\r\n\r\n.btn.btn-aqua {\r\n  color: var(--white);\r\n  border: var(--aqua-001);\r\n  background-color: var(--aqua-001);\r\n  &:hover,\r\n  &:active {\r\n    color: var(--white);\r\n    border-color: darken(var(--aqua-001), 9%);\r\n    background-color: darken(var(--aqua-001), 5%);\r\n  }\r\n  &:active:focus {\r\n    color: var(--white);\r\n    border-color: darken(var(--aqua-001), 14%);\r\n    background-color: darken(var(--aqua-001), 10%);\r\n  }\r\n  &:disabled {\r\n    color: var(--aqua-003);\r\n    opacity: 1;\r\n    cursor: not-allowed;\r\n    border-color: darken(var(--aqua-001), 9%);\r\n    background-color: darken(var(--aqua-001), 5%);\r\n  }\r\n}\r\n\r\n.btn.btn-red {\r\n  color: var(--white);\r\n  border: var(--red-001);\r\n  background-color: var(--red-001);\r\n  &:hover,\r\n  &:active {\r\n    color: var(--white);\r\n    border-color: darken(var(--red-001), 9%);\r\n    background-color: darken(var(--red-001), 5%);\r\n  }\r\n  &:active:focus {\r\n    color: var(--white);\r\n    border-color: darken(var(--red-001), 14%);\r\n    background-color: darken(var(--red-001), 10%);\r\n  }\r\n}\r\n\r\n.btn.btn-dark {\r\n  color: var(--white);\r\n  border: var(--grey-003);\r\n  background-color: var(--grey-003);\r\n  &:hover,\r\n  &:active {\r\n    color: var(--white);\r\n    border-color: darken(var(--grey-003), 9%);\r\n    background-color: darken(var(--grey-003), 5%);\r\n  }\r\n  &:active:focus {\r\n    color: var(--white);\r\n    border-color: darken(var(--grey-003), 14%);\r\n    background-color: darken(var(--grey-003), 10%);\r\n  }\r\n}\r\n\r\n.btn.btn-white {\r\n  color: var(--aqua-001);\r\n  border: var(--white);\r\n  background-color: var(--white);\r\n  &:hover,\r\n  &:active {\r\n    color: var(--aqua-001);\r\n    border-color: darken(var(--white), 9%);\r\n    background-color: darken(var(--white), 5%);\r\n  }\r\n  &:active:focus {\r\n    color: var(--aqua-001);\r\n    border-color: darken(var(--white), 9%);\r\n    background-color: darken(var(--white), 5%);\r\n  }\r\n}\r\n\r\n.btn-wrapper {\r\n  text-align: center;\r\n  padding-top: 29px;\r\n}\r\n\r\n/* CONTENT CONTAINER */\r\n.content-wrapper {\r\n  background: var(--white);\r\n  -webkit-box-shadow: 10px 11px 52px 0px rgba(222, 223, 224, 1);\r\n  -moz-box-shadow: 10px 11px 52px 0px rgba(222, 223, 224, 1);\r\n  box-shadow: 10px 11px 52px 0px rgba(222, 223, 224, 1);\r\n  > h3 {\r\n    color: var(--white);\r\n    background-color: var(--aqua-001);\r\n    padding: 8px 30px;\r\n    font-size: 1rem;\r\n    font-family: var(--opensans-font);\r\n    font-weight: var(--opensans-regular);\r\n    text-transform: uppercase;\r\n    letter-spacing: 1px;\r\n    line-height: 26px;\r\n\r\n    svg {\r\n        margin-right: 12px;\r\n    }\r\n  }\r\n  .content-body {\r\n    padding: 29px;\r\n    &.no-padding {\r\n      padding: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.content-wrapper.dark > h3 {\r\n  color: var(--white);\r\n  background-color: var(--grey-003);\r\n}\r\n.content-wrapper.add-margin-top {\r\n    margin-top: 42px;\r\n}\r\n.content-wrapper.add-margin-bottom {\r\n    margin-bottom: 42px;\r\n}\r\n\r\n/* TABLE */\r\n\r\n.table {\r\n  display: table;\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  border: 1px solid var(--border-grey);\r\n  border-collapse: collapse;\r\n  font-size: 13px;\r\n  font-family: var(--opensans-font);\r\n  font-weight: var(--opensans-light);\r\n\r\n  header {\r\n    display: table-row;\r\n\r\n    > div {\r\n      font-size: 1rem;\r\n      font-family: var(--roboto-font);\r\n      font-weight: var(--roboto-regular);\r\n      display: table-cell;\r\n      padding: 11px 14px;\r\n      border: 1px solid var(--border-grey);\r\n      vertical-align: bottom;\r\n    }\r\n  }\r\n\r\n  > div {\r\n    display: table-row;\r\n\r\n    > div {\r\n      display: table-cell;\r\n      padding: 11px 14px;\r\n      border: 1px solid var(--border-grey);\r\n      > div {\r\n        display: none;\r\n      }\r\n      span{\r\n        &.nowrapping{\r\n          white-space: nowrap;\r\n        }\r\n        \r\n      }\r\n    }\r\n    &:nth-of-type(odd) {\r\n      background-color: var(--white-003);\r\n    }\r\n    &:nth-of-type(even) {\r\n      background-color: var(--white-002);\r\n    }\r\n  }\r\n}\r\n\r\n/* FOOTER */\r\n\r\nfooter {\r\n  background: var(--grey-003);\r\n\r\n  .footer-flex {\r\n    display: flex;\r\n    flex-flow: row nowrap;\r\n    justify-content: space-between;\r\n\r\n    padding-top: 30px;\r\n    padding-bottom: 30px;\r\n    div {\r\n      flex: 1;\r\n      margin-right: 2%;\r\n      h3 {\r\n        color: var(--aqua-002);\r\n        font-size: 1rem;\r\n        font-family: var(--opensans-font);\r\n        font-weight: var(--opensans-semibold);\r\n        text-transform: uppercase;\r\n        line-height: 18px;\r\n      }\r\n      h4 {\r\n        color: var(--white);\r\n        font-size: 1rem;\r\n        font-family: var(--roboto-font);\r\n        font-weight: var(--roboto-light);\r\n        padding-top: 11px;\r\n        padding-top: 11px;\r\n      }\r\n      ul {\r\n        padding-top: 11px;\r\n        li {\r\n          line-height: 15px;\r\n          padding-bottom: 8px;\r\n          a {\r\n            color: var(--white);\r\n            font-size: 1rem;\r\n            font-family: var(--roboto-font);\r\n            font-weight: var(--roboto-light);\r\n            display: inline-block;\r\n            line-height: 14px;\r\n            svg {\r\n              color: var(--aqua-001);\r\n              font-size: 22px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n      &.follow-us {\r\n        text-align: right;\r\n        ul {\r\n          li {\r\n            padding: 0;\r\n            display: inline-block;\r\n            line-height: 12px;\r\n            margin-right: 12px;\r\n            &:last-child {\r\n              margin-right: 0;\r\n            }\r\n          }\r\n        }\r\n      }\r\n      &:last-child {\r\n        margin-right: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  /* FOOTER > COPYRIGHT */\r\n\r\n  .copyright {\r\n    background: var(--grey-001);\r\n    .copyright-flex {\r\n      display: flex;\r\n      flex-flow: row nowrap;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      color: var(--grey-005);\r\n      font-family: var(--roboto-font);\r\n      font-weight: var(--roboto-light);\r\n      font-size: 15px;\r\n      line-height: 17px;\r\n      padding-top: 15px;\r\n      padding-bottom: 15px;\r\n\r\n      span a {\r\n        color: var(--grey-006);\r\n      }\r\n      span a:hover {\r\n        color: var(--aqua-001);\r\n      }\r\n\r\n      ul {\r\n        li {\r\n          display: inline-block;\r\n          border-left: 1px solid var(--grey-005);\r\n          margin-left: 8px;\r\n          padding-left: 10px;\r\n          line-height: 16px;\r\n          a {\r\n            color: var(--grey-005);\r\n            img{\r\n              width: 8.125rem;\r\n            }\r\n          }\r\n          &:first-of-type {\r\n            border: none;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .social-icon {\r\n    height: 25px;\r\n  }\r\n}\r\n\r\n/* GLOBAL */\r\n\r\nau-viewport {\r\n  display: block;\r\n  height: 100%;\r\n  width: 100%;\r\n  min-height: calc(100vh - 358px );\r\n}\r\n\r\nsection.au-animate {\r\n  -webkit-animation: fadeIn 1s;\r\n  animation: fadeIn 1s;\r\n}\r\n\r\n@-webkit-keyframes fadeIn {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/** Error & Validation message styling **/\r\n\r\n.error {\r\n  border: 1px solid #cc0000 !important;\r\n}\r\n\r\n.validation-message-container {\r\n  margin-top: 0.46875rem;\r\n  display: block;\r\n  color: #cc0000;\r\n}\r\n\r\n/** NProgress bar custom Brand styling **/\r\n\r\n#nprogress {\r\n  .bar {\r\n    background: var(--aqua-001);\r\n  }\r\n  .peg {\r\n    box-shadow: 0 0 10px var(--aqua-001), 0 0 5px var(--aqua-001);\r\n  }\r\n  .spinner-icon {\r\n    border-top-color: var(--aqua-001);\r\n    border-left-color: var(--aqua-001);\r\n  }\r\n}\r\n\r\n.go-back {\r\n  clear: both;\r\n  text-align: center;\r\n  padding-top: 40px;\r\n  padding-bottom: 40px;\r\n}\r\n\r\n.center {\r\n  text-align: center;\r\n  width: 15%;\r\n}\r\n\r\n@media screen and (max-width: 767px){\r\n  .center {   \r\n    width: unset;\r\n  } \r\n}\r\n\r\n/* HEADER */\r\n.profile-menu {\r\n  display: none;\r\n  position: absolute;\r\n  left: 0px;\r\n  top: 60px;\r\n  background-color: var(--grey-002);\r\n\r\n  min-width: 160px;\r\n  overflow: auto;\r\n  z-index: 1;\r\n}\r\n\r\n.profile-menu a {\r\n  color: var(--grey-006) !important;\r\n  font-size: 13px;\r\n  padding-left: 30px;\r\n}\r\n\r\n.profile-menu a:hover {\r\n  background-color: var(--grey-003);\r\n}\r\n\r\n.profile-menu-show {\r\n  display: block !important;\r\n}\r\n\r\n.profile-close-btn {\r\n  display: none;\r\n}\r\n\r\n.profile-menu-sublinks {\r\n  background-color: var(--grey-005);\r\n  max-height: 0px;\r\n  transition: max-height 0.4s ease-out;\r\n  overflow: hidden;\r\n}\r\n\r\n.profile-menu-sublinks a {\r\n  color: var(--grey-002) !important;\r\n}\r\n\r\n.profile-menu-sublinks-show {\r\n  max-height: 300px;\r\n}\r\n\r\n.profile-menu-sublinks a:hover {\r\n  background-color: var(--grey-004);\r\n}\r\n\r\n.profile-sublinks-arrow {\r\n  margin-left: 5px;\r\n  margin-bottom: 3px;\r\n  pointer-events: none;\r\n} \r\n.profile-sublinks-arrow-up {\r\n  margin-left: 5px;\r\n  margin-bottom: -2px;\r\n  pointer-events: none;\r\n}\r\n\r\n.paidFunded{\r\n  color: var(--green-001);\r\n  font-weight: var(--roboto-semibold)\r\n}\r\n\r\np {\r\n  font-family: var(--opensans-font);  \r\n  font-weight: var(--opensans-light);\r\n  font-size: 13px;\r\n}\r\n\r\n.title{\r\n  text-transform: uppercase; \r\n  padding-bottom: 15px;\r\n  font-family: unset;\r\n  font-weight: var(--roboto-semibold);\r\n}\r\n\r\n.creditAmount{\r\n  color: var(--red-001);\r\n}\r\n\r\n/************** Media css start **************/\r\n\r\n@media screen and (--xl-viewport) {\r\n  .content-wrapper {\r\n    > h3 {\r\n      padding: 8px 15px;\r\n    }\r\n    .content-body {\r\n        padding: 15px;\r\n    }\r\n  }\r\n  .table {\r\n    header {\r\n      > div {\r\n        font-size: 14px;\r\n      }\r\n    }\r\n  }\r\n  .btn {\r\n    padding: 4px 18px;\r\n  }\r\n  .btn-wrapper {\r\n    padding-top: 15px;\r\n  }\r\n}\r\n\r\n@media screen and (--lg-viewport) {\r\n  footer {\r\n    .copyright {\r\n      .copyright-flex {\r\n        font-size: 14px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (--md-viewport) {\r\n  .content-wrapper {\r\n    > h3 {\r\n      font-size: 15px;\r\n    }\r\n    .content-body {\r\n      padding: 35px 15px;\r\n    }\r\n  }\r\n\r\n  .table {\r\n    display: block;\r\n    border: none;\r\n    header {\r\n      display: none;\r\n    }\r\n    > div {\r\n      display: block;\r\n      background-color: transparent;\r\n      &:last-child {\r\n        > div {\r\n          &:last-child {\r\n            margin-bottom: 0;\r\n          }\r\n        }\r\n      }\r\n\r\n      > div {\r\n        display: block;\r\n        text-align: center;\r\n        padding: 11px 15px;\r\n        border-top: none;\r\n        &:nth-of-type(odd) {\r\n          background-color: var(--white-003);\r\n        }\r\n        &:nth-of-type(even) {\r\n          background-color: var(--white-002);\r\n        }\r\n        &:first-child {\r\n          border-top: 3px solid #04c3ca;\r\n        }\r\n        &:last-child {\r\n            margin-bottom: 20px;\r\n        }\r\n\r\n        > div {\r\n          display: block;\r\n          font-size: 15px;\r\n          font-family: var(--roboto-font);\r\n          font-weight: var(--roboto-regular);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .btn {\r\n    padding: 4px 10px;\r\n  }\r\n  .btn.btn-aqua,\r\n  .btn.btn-dark {\r\n    margin: 0;\r\n    padding: 9px 25px;\r\n  }\r\n\r\n  header {\r\n    .user {\r\n      top: 0;\r\n      .notifications,\r\n      .user-profile {\r\n        display: none !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  footer {\r\n    .footer-flex {\r\n      flex-flow: column nowrap;\r\n      padding: 35px 0;\r\n      div {\r\n        margin-right: 0;\r\n        margin-bottom: 25px;\r\n        text-align: center;\r\n        h4 {\r\n            padding-top: 2px;\r\n        }\r\n        ul {\r\n            padding-top: 8px;\r\n        }\r\n        &.follow-us {\r\n          text-align: center;\r\n          ul {\r\n            text-align: center;\r\n            padding-top: 12px;\r\n            li {\r\n              margin: 0 15px;\r\n              &:first-of-type {\r\n                margin-left: 0;\r\n              }\r\n            }\r\n          }\r\n        }\r\n        &:last-child {\r\n          margin-bottom: 0;\r\n        }\r\n      }\r\n    }\r\n    .copyright {\r\n      .copyright-flex {\r\n        flex-flow: column nowrap;\r\n        flex-direction: column-reverse;\r\n        text-align: center;\r\n        div {\r\n            margin-bottom: 15px;\r\n          &:first-child {\r\n            margin-bottom: 0;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (--sm-viewport) {\r\n  .navbar {\r\n    .container {\r\n      padding: 0;\r\n      display: inline-block;\r\n    }\r\n  }\r\n  a.nav-link {\r\n    flex: 1;\r\n    text-align: center;\r\n  }\r\n  footer {\r\n    .copyright {\r\n      .copyright-flex {\r\n        div {\r\n          ul {\r\n            li {\r\n                margin-left: 4px;\r\n                padding-left: 6px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .profile-menu {\r\n    display: block;\r\n    min-width: 250px;\r\n    height: 100%;\r\n    width: 250px;\r\n    position: fixed;\r\n    z-index: 100;\r\n    top: 0;\r\n    right: -250px;\r\n    left: auto;\r\n    overflow-x: hidden;\r\n    transition: right .5s;\r\n    padding-top: 40px;\r\n  }\r\n\r\n  .profile-menu a {\r\n    display: block;\r\n    color: var(--grey-006);\r\n    white-space: nowrap;\r\n    font-size: 15px;\r\n    padding-left: 0px;\r\n  }\r\n\r\n  .profile-menu-show {\r\n    right: 0px;\r\n  }\r\n  \r\n  .profile-close-btn {\r\n    display: block;\r\n    position: absolute;\r\n    top: 0;\r\n    right: 25px;\r\n    font-size: 30px !important;\r\n    margin-left: 50px;\r\n    color: var(--grey-006) !important;\r\n  }\r\n\r\n  a.profile-close-btn:hover  {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .profile-menu-sublinks {\r\n    max-height: 0px;\r\n    transition: max-height 0.4s ease-out;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .profile-menu-sublinks-show {\r\n    max-height: 300px;\r\n  }\r\n  \r\n}\r\n\r\n.g-pl-4 {\r\n    padding-left: 0.25rem !important;\r\n}\r\n\r\n.g-pb-9 {\r\n    padding-bottom: 0.5625rem !important;\r\n}\r\n\r\n.g-pt-15 {\r\n    padding-top: 0.9375rem !important;\r\n}\r\n\r\n.g-pr-3 {\r\n    padding-right: 0.1875rem !important;\r\n}\r\n\r\n.g-pl-15 {\r\n    padding-left: 0.9375rem !important;\r\n}\r\n\r\n.g-pr-5 {\r\n    padding-right: 0.3125rem !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
